import { apiSlice, createClientV2QueryFn } from 'store/slices/api';
import { parseQueryParams } from 'store/slices/utils';
import { ClientV2POSTResponse, ListResponse, QueryParams } from 'types/api';
import { CLIENT_V2_URLS } from 'store/slices/constants/clientV2';
import {
  AddTeamsRequest,
  RemoveTeamsRequest,
  UserSchema,
} from 'types/clientV2/users';

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUsersV2: builder.query<
      ListResponse<UserSchema>,
      QueryParams<UserSchema>
    >({
      queryFn: createClientV2QueryFn((params) =>
        CLIENT_V2_URLS.USERS(parseQueryParams<UserSchema>(params))
      ),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(
                ({ id }: UserSchema) =>
                  ({
                    type: 'UsersV2',
                    id,
                  } as const)
              ),
              { type: 'UsersV2', id: 'LIST' },
            ]
          : [{ type: 'UsersV2', id: 'LIST' }],
    }),
    addTeams: builder.mutation<
      ClientV2POSTResponse<UserSchema>,
      AddTeamsRequest
    >({
      query: (data) => ({
        url: CLIENT_V2_URLS.USERS_ADD_TEAMS,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'UsersV2', id: 'LIST' }],
    }),
    removeTeams: builder.mutation<
      ClientV2POSTResponse<UserSchema>,
      RemoveTeamsRequest
    >({
      query: (data) => ({
        url: CLIENT_V2_URLS.USERS_REMOVE_TEAMS,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'UsersV2', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetUsersV2Query,
  useAddTeamsMutation,
  useRemoveTeamsMutation,
} = extendedApiSlice;
